export default function initPersonaChooser() {
	const choosers = document.querySelectorAll('.persona-chooser');
	const chooserBlocks = document.querySelectorAll('.persona-chooser-block');
	const helperBlocks = document.querySelectorAll('.persona-block-helper');
	const STORAGE_KEY = 'careerready_selected_persona';
	const VISIBILITY_STORAGE_KEY = 'careerready_persona_chooser_hidden';
	
	function savePersonaSelection(persona) {
		try {
			localStorage.setItem(STORAGE_KEY, persona);
		} catch (error) {
			console.warn('Could not save persona selection to localStorage:', error);
		}
	}
	
	function getPersonaSelection() {
		try {
			return localStorage.getItem(STORAGE_KEY);
		} catch (error) {
			console.warn('Could not load persona selection from localStorage:', error);
			return null;
		}
	}
	
	function saveChooserVisibility(isHidden) {
		try {
			localStorage.setItem(VISIBILITY_STORAGE_KEY, isHidden ? 'true' : 'false');
		} catch (error) {
			console.warn('Could not save chooser visibility to localStorage:', error);
		}
	}
	
	function getChooserVisibility() {
		try {
			return false;
			const hidden = localStorage.getItem(VISIBILITY_STORAGE_KEY);
			return hidden === 'true';
		} catch (error) {
			console.warn('Could not load chooser visibility from localStorage:', error);
			return false;
		}
	}
	
	function dispatchPersonaEvent(persona, element, chooser, isInitial = false) {
		const event = new CustomEvent('personaSelected', {
			detail: { 
				persona: persona,
				element: element,
				chooser: chooser,
				isInitialLoad: isInitial
			}
		});
		document.dispatchEvent(event);
	}
	
	function selectPill(pill, chooserElement, saveToStorage = true, isInitial = false) {
		const pills = chooserElement.querySelectorAll('.persona-pill');
		
		pills.forEach(p => {
			p.classList.remove('selected');
			p.dataset.selected = 'false';
		});
		
		pill.classList.add('selected');
		pill.dataset.selected = 'true';
		
		if (saveToStorage) {
			savePersonaSelection(pill.dataset.persona);
		}
		
		dispatchPersonaEvent(pill.dataset.persona, pill, chooserElement, isInitial);
	}
	
	choosers.forEach(chooserElement => {
		const pills = chooserElement.querySelectorAll('.persona-pill');
		
		const savedPersona = getPersonaSelection();
		if (savedPersona) {
			const savedPill = chooserElement.querySelector(`[data-persona="${savedPersona}"]`);
			if (savedPill) {
				selectPill(savedPill, chooserElement, false, true);
			}
		}
		
		pills.forEach(pill => {
			pill.addEventListener('click', function() {
				selectPill(this, chooserElement, true, false);
			});
		});
	});
	
	const isHidden = getChooserVisibility();
	
	chooserBlocks.forEach(block => {
		if (isHidden) {
			block.style.display = 'none';
		}
		
		const closeIcon = block.querySelector('.icon-close');
		if (closeIcon) {
			closeIcon.addEventListener('click', function() {
				chooserBlocks.forEach(b => b.style.display = 'none');
				helperBlocks.forEach(h => h.style.display = 'none');
				saveChooserVisibility(true);
				
				const event = new CustomEvent('personaChooserHidden', {
					detail: { 
						chooserBlocks: chooserBlocks,
						helperBlocks: helperBlocks
					}
				});
				document.dispatchEvent(event);
			});
		}
	});
	
	helperBlocks.forEach(block => {
		if (isHidden) {
			block.style.display = 'none';
		}
	});
}
